.root {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 4px 0;
}

.history {
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 4px 2px;
  scroll-behavior: smooth;
}

.bubble {
  border-radius: 18px;
  font-size: 15px;
  line-height: 1.5;
  max-width: 82%;
  padding: 12px 16px;
  white-space: pre-wrap;
  word-break: break-word;
}

.bubble-role-user {
  align-self: flex-end;
  background: var(--color-primary, #a5b4fc);
  border-bottom-right-radius: 6px;
  color: var(--color-primary-foreground, #312e81);
}

.bubble-role-assistant {
  align-self: flex-start;
  background: var(--color-secondary, #f4f4f5);
  border-bottom-left-radius: 6px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.03);
  color: var(--color-foreground, #18181b);
}

.collected {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  padding: 0;
}

.collected-row {
  align-items: baseline;
  background: var(--color-secondary, #f4f4f5);
  border-radius: 999px;
  display: inline-flex;
  font-size: 12px;
  gap: 6px;
  padding: 4px 10px;
}

.collected-key {
  text-transform: capitalize;
}

.confirm {
  background: color-mix(
    in srgb,
    var(--color-primary, #a5b4fc) 5%,
    var(--color-background, #fff)
  );
  border: 1px solid var(--color-border, #e4e4e7);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 12px;
  padding: 12px;
  position: relative;
}

.confirm::before {
  background: var(--color-primary, #a5b4fc);
  border-radius: 2px;
  content: '';
  height: 22px;
  left: 0;
  position: absolute;
  top: 12px;
  width: 3px;
}

.confirm-actions {
  border-top: 1px solid var(--color-border, #e4e4e7);
  display: flex;
  gap: 8px;
  justify-content: flex-end;
  padding-top: 10px;
}

.executing,
.done,
.cancelled,
.error {
  border: 1px solid var(--color-border, #e4e4e7);
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px;
}

.executing {
  align-items: center;
  background: var(--color-secondary, #f4f4f5);
  color: var(--color-muted-fg, #71717a);
  flex-direction: row;
  font-size: 13px;
}

.done {
  background: var(--color-success, #d1fae5);
  border-color: var(--color-success-border, #a7f3d0);
}

.cancelled {
  background: var(--color-secondary, #f4f4f5);
  color: var(--color-muted-fg, #71717a);
  font-size: 13px;
}

.error {
  background: var(--color-danger-bg, #fff1f2);
  border-color: color-mix(in srgb, var(--color-danger, #e11d48) 30%, transparent);
  color: var(--color-danger, #e11d48);
  font-size: 13px;
}

.candidates {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 4px 0;
}

.candidates-label {
  color: var(--color-muted-fg, #71717a);
  font-size: 11px;
  font-weight: 500;
  letter-spacing: 0.06em;
  padding-left: 2px;
  text-transform: uppercase;
}

.candidate {
  align-items: center;
  background: var(--color-background, #fff);
  border: 1px solid var(--color-border, #e4e4e7);
  border-radius: 10px;
  cursor: pointer;
  display: flex;
  font: inherit;
  gap: 12px;
  padding: 10px 12px;
  text-align: left;
  transition:
    border-color 120ms ease,
    background 120ms ease,
    transform 120ms ease;
  width: 100%;
}

.candidate:hover {
  background: var(--color-surface, #fafafa);
  border-color: var(--color-border-strong, #d4d4d8);
}

.candidate:focus-visible {
  border-color: var(--color-focus, #1c7fd6);
  box-shadow: 0 0 0 2px var(--color-focus, #1c7fd6);
  outline: none;
}

.candidate:active {
  transform: translateY(1px);
}

.candidate:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

.candidate-thumb {
  background: var(--color-secondary, #f4f4f5);
  border-radius: 6px;
  flex-shrink: 0;
  height: 50px;
  object-fit: cover;
  width: 50px;
}

.candidate-thumb-placeholder {
  background: var(--color-secondary, #f4f4f5);
  border-radius: 6px;
  flex-shrink: 0;
  height: 50px;
  width: 50px;
}

.candidate-text {
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.candidate-title {
  letter-spacing: -0.01em;
  line-height: 1.3;
}

.candidate-id {
  color: var(--color-placeholder, #a1a1aa);
  font-family: var(--font-mono, ui-monospace, SFMono-Regular, monospace);
  font-size: 9.5px;
  letter-spacing: 0;
  margin-top: 2px;
  opacity: 0.85;
  word-break: break-all;
}
